module.exports = __webpack_public_path__ + "static/media/placas (5).aea75018.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/fotos/Placas/placas (5).jpg
// module id = 355
// module chunks = 0